import React from 'react'
import {IconFont} from '@wap/components'
import {Document, Page, pdfjs} from 'react-pdf'
import {Tooltip, Input} from 'zarm'
import { debounce } from '@utils/index';
import './inde.less'
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry'

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

let timer = null
class PdfLook extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
      pageNumber: 1, // 当前页数
      numPages: 1, // 总页数
      pageWidth: document.documentElement.clientWidth - 32, // pdf宽度
      pageHeight: document.documentElement.clientHeight - 60, // pdf高度
      pageNumberInput: 1, // input框value
      pageNumberFocus: false, // input框集中

      ifEdit: false, // 是否可手势缩放
      // 手势放大缩小相关
      isDoubleTouch: false, // 是否为多触点
      isTouch: false, // 是否触发
      startList: [], // 触点坐标
      nowTime: '', // 当前事件
      delta: '', // 两次触发事件时间差
      startPosition: ['', ''], // 滑动起点
      movePosition: ['', ''], // 移动
      endPosition: ['', ''], // 结束点坐标
      transform: '', // 变换
      transformOrigin: '', // 变换中心
      originLast: [],
      maxSwipeLeft: '',
      maxSwipeRight: '',
      maxSwipeTop: '',
      maxSwipeBottom: '',
      tMatrix: [1, 0, 0, 1, 0, 0], //x缩放，无，无，y缩放，x平移，y平移
      scale: 1,
      pdfStyle: {}, // pdf的样式
      isHorizontal: false// 是否是横屏
    }
  }
  handlePdfDicChange = () => {
    const orientation = window.orientation;
    const pageWidth = document.documentElement.clientWidth - 32; // pdf宽度
    const pageHeight = document.documentElement.clientHeight - 60; // pdf高度
    console.log(window.orientation, this.pdfPage, window);
    if (orientation === 180 || orientation === 0) {
      console.log('竖屏状态')
      this.setState({ pdfStyle: { width: `${pageWidth}px`, height: `${pageHeight}px`, rotate: 0 }, pageWidth, isHorizontal: true })
    }
    if (orientation === 90 || orientation === -90) {
      console.log('横屏状态')
      this.setState({ pdfStyle: { width: `${pageWidth}px`, height: `${pageHeight}px`, rotate: 90, pageWidth, isHorizontal: true }})
    }
  }

  componentDidMount() {
    // window.addEventListener('orientationchange', this.handlePdfDicChange, false);
  }
  componentWillUnmount() {
    // window.removeEventListener('orientationchange', this.handlePdfDicChange);
  }

  // 文档加载成功
  onDocumentLoadSuccess = ({numPages}) => {
    this.setState({
      ifEdit: true,
      numPages,
    })
  }

  // 显示隐藏
  handleChangeVisible = (visible) => {
    this.setState({visible})
    visible && this.handleChangeDirection(true);
    document.body.style.overflow = visible ? 'scroll' : ' hidden'
  }

  // 上一页
  lastPage = () => {
    if (this.state.pageNumber == 1) {
      return
    }
    const page = this.state.pageNumber - 1
    this.setState({pageNumber: page, pageNumberInput: page})
  }

  // 下一页
  nextPage = () => {
    if (this.state.pageNumber == this.state.numPages) {
      return
    }
    const page = this.state.pageNumber + 1
    this.setState({pageNumber: page, pageNumberInput: page})
  }
  //
  onPageNumberFocus = (e) => {
    this.setState({pageNumberFocus: true})
  }
  //
  onPageNumberBlur = (e) => {
    this.setState({
      pageNumberFocus: false,
      pageNumberInput: this.state.pageNumber,
    })
  }
  // 分页改变
  onPageNumberChange = (e) => {
    let value = e
    value = value <= 0 ? 1 : value
    value = value >= this.state.numPages ? this.state.numPages : value
    this.setState({pageNumberInput: value})
  }
  // 对应页面
  toPage = (e) => {
    this.setState({pageNumber: Number(e)})
  }

  /**
   *
   * 变换中心位置
   * @param {*} midPoint 中心点坐标相对目标元素坐标
   * @memberof PdfLook
   */
  gesturestart = (midPoint = []) => {
    const x = midPoint[0]
    const y = midPoint[1]
    const originLast = midPoint
    const transformOrigin = `${x}px ${y}px`
    console.log(originLast, transformOrigin)
    this.setState({
      originLast,
      transformOrigin,
    })
  }
  // 进行缩放变换, 缩放范围为1 ~ 3；
  gesturechange = (scale) => {
    const {tMatrix} = this.state
    const sc = parseFloat(scale)
    tMatrix[0] =
      tMatrix[0] + sc - 1 >= 1 && tMatrix[0] + sc - 1 < 3
        ? tMatrix[0] + sc - 1
        : tMatrix[0]
    tMatrix[3] =
      tMatrix[3] + sc - 1 >= 1 && tMatrix[3] + sc - 1 < 3
        ? tMatrix[3] + sc - 1
        : tMatrix[3]
    tMatrix[0] = Math.floor(tMatrix[0] * 100) / 100
    tMatrix[3] = Math.floor(tMatrix[3] * 100) / 100
    const temp = tMatrix.join(',')
    const transform = 'matrix(' + temp + ')'
    this.setState({
      transform,
    })
  }

  // 获取移动边界范围边界
  gestureend = () => {
    this.maxMove()
  }

  /*
   * 两点的距离
   */
  getDistance = (p1, p2) => {
    const x = p2.pageX - p1.pageX
    const y = p2.pageY - p1.pageY
    return Math.sqrt(x * x + y * y)
  }
  /*
   * 两点的夹角
   */
  getAngle = (p1, p2) => {
    const x = p1.pageX - p2.pageX
    const y = p1.pageY - p2.pageY
    return (Math.atan2(y, x) * 180) / Math.PI
  }

  /*
   * 获取中点
   */
  getMidPoint = (p1, p2) => {
    const x = (p1.pageX + p2.pageX) / 2
    const y = (p1.pageY + p2.pageY) / 2
    return [x, y]
  }

  maxMove = () => {
    //最大可拖动范围
    const {tMatrix, originLast, pageWidth, pageHeight} = this.state
    const sca = tMatrix[0]
    let maxSwipeLeft = Math.abs(sca - 1) * originLast[0]
    let maxSwipeRight = Math.abs(sca - 1) * (pageWidth - originLast[0])
    let maxSwipeTop = Math.abs(sca - 1) * originLast[1]
    let maxSwipeBottom = Math.abs(sca - 1) * (pageHeight - originLast[1])
    this.setState({
      maxSwipeLeft,
      maxSwipeRight,
      maxSwipeTop,
      maxSwipeBottom,
    })
  }

  // 拖动图片，需考虑是否在可拖动范围
  swipeMove = (distance) => {
    const {tMatrix, maxSwipeTop, maxSwipeRight, maxSwipeLeft, maxSwipeBottom} =
      this.state
    if (!maxSwipeLeft || !maxSwipeRight || !maxSwipeTop || !maxSwipeBottom)
      return
    if (distance[0] > 0 && maxSwipeLeft < tMatrix[4]) return
    if (distance[0] < 0 && maxSwipeRight < -tMatrix[4]) return
    if (distance[1] > 0 && maxSwipeTop < tMatrix[5]) return
    if (distance[1] < 0 && maxSwipeBottom < -tMatrix[5]) return

    tMatrix[4] = tMatrix[4] + parseInt(distance[0])
    tMatrix[5] = tMatrix[5] + parseInt(distance[1])

    const temp = tMatrix.join(',')
    const transform = 'matrix(' + temp + ')'
    this.setState({
      transform,
      tMatrix,
    })
  }

  // 双击点击缩放
  doubleTouch = (position) => {
    const {tMatrix} = this.state
    const originLast = position
    const transformOrigin = position[0] + 'px ' + position[1] + 'px'
    tMatrix[0] = 2
    tMatrix[3] = 2
    let temp = tMatrix.join(',')
    const transform = 'matrix(' + temp + ')'
    this.setState({
      originLast,
      transformOrigin,
      transform,
    })
    this.maxMove()
  }

  /**
   *
   * 若e.touches.length>=2,为双指事件,
   * 获取触点坐标（触点坐标-目标元素.offsetLeft/Top）计算两个点中点 添加到事件属性中，
   * 改变相关状态，触发gesturestart事件；
   * @param {*} e
   * @memberof PdfLook
   */
  touchstart = (e) => {
    const {ifEdit} = this.state
    if (!ifEdit) return
    let isDoubleTouch = false
    let [startList, startPosition] = [[], []]
    let delta = 0
    let nowTime = ''
    // 是否两个点在屏幕上
    if (e.touches.length >= 2) {
      isDoubleTouch = true
      startList = e.touches // 得到第一组两个点
      const screenMinPoint = this.getMidPoint(startList[0], startList[1]) // 获取两个触点中心坐标
      const midPoint = [
        screenMinPoint[0] - e.target.offsetLeft,
        screenMinPoint[1] - e.target.offsetTop,
      ] //获取中心点坐标相对目标元素坐标
      this.gesturestart(midPoint)
    } else {
      let nTime = this.state.nowTime
      delta = Date.now() - nTime //计算两次点击时间差
      nowTime = Date.now()
      startPosition = [e.touches[0].pageX, e.touches[0].pageY]
      if (delta > 0 && delta <= 250) {
        this.doubleTouch([
          e.touches[0].pageX - e.target.offsetLeft,
          e.touches[0].pageY - e.target.offsetTop,
        ])
      }
    }
    this.setState({
      isDoubleTouch,
      startList,
      delta,
      nowTime,
      startPosition,
    })
  }

  touchMove = (e) => {
    const {ifEdit} = this.state
    if (!ifEdit) return
    const {isDoubleTouch, isTouch, startList} = this.state
    let [movePosition, endPosition, startPosition] = [[], [], []]
    if (e.touches.length >= 2 && isDoubleTouch) {
      const now = e.touches //得到第二组两个点
      const scale =
        this.getDistance(now[0], now[1]) /
        this.getDistance(startList[0], startList[1]) //得到缩放比例
      const rotation =
        this.getAngle(now[0], now[1]) -
        this.getAngle(startList[0], startList[1]) //得到旋转角度差
      console.log(scale, rotation)
      this.gesturechange(scale.toFixed(2))
      this.gesturechange(rotation.toFixed(2))
    } else if (isTouch) {
      movePosition = [e.touches[0].pageX, e.touches[0].pageY]
      endPosition = movePosition
      movePosition = [
        movePosition[0] - startPosition[0],
        movePosition[1] - startPosition[1],
      ]
      startPosition = [e.touches[0].pageX, e.touches[0].pageY]
      this.swipeMove([movePosition[0].toFixed(2), movePosition[1].toFixed(2)])
      this.setState({
        startPosition,
        movePosition,
        endPosition,
      })
    }
  }

  touchEnd = (e) => {
    const {ifEdit} = this.state
    if (!ifEdit) return
    const {isDoubleTouch} = this.state
    if (isDoubleTouch) {
      this.setState({
        isDoubleTouch: false,
      })
      this.gestureend()
    }
  }
  handleChangeDirection = (isHorizontal) => {
    const pageWidth = document.documentElement.clientWidth - 32; // pdf宽度
    if (isHorizontal) { // 改为横屏
      this.setState({ pdfStyle: { top: '10px', left: '42px', rotate: 90, transformOrigin: 'left' }, pageWidth, isHorizontal })
    } else {
      this.setState({ pdfStyle: { bottom: '10px', left: '10px', rotate: 0 }, pageWidth, isHorizontal })
    }
  }

  render() {
    const {
      visible,
      pageNumber,
      numPages,
      pageWidth,
      pageHeight,
      transform,
      scale,
      transformOrigin,
      pageNumberFocus,
      pageNumberInput,
      pdfStyle,
      isHorizontal
    } = this.state
    return (
      visible && (
        <div className="pdf_root">
          <div className="header">
            <IconFont
              onClick={() => this.handleChangeVisible(false)}
              type="icon-zhankai"
              style={{
                fontSize: 28,
                padding: 8,
                color: '#fff',
                transform: 'rotate(90deg)',
              }}
            />
            <div className="examName">pdf文件</div>
          </div>
          <div
            className="pdf_con"
            style={{position: 'relative',transform: transform, transformOrigin: transformOrigin }}
            onTouchStart={this.touchstart}
            onTouchMove={this.touchMove}
            onTouchEnd={this.touchEnd}
          >
            <Document
              file={this.props.url}
              loading={<div style={{color: '#fff'}}>加载中...</div>}
              onLoadSuccess={this.onDocumentLoadSuccess}
            >
              <Page ref={r => this.pdfPage = r} pageNumber={pageNumber} width={pageWidth} rotate={pdfStyle.rotate} />
              {/* {new Array(numPages).fill('').map((item, index) => {
                return (
                  <div key={index}>
                    <Page
                      pageNumber={pageNumber + index}
                      width={pageWidth}
                      // height={pageHeight}
                    />
                    <br />
                  </div>
                )
              })} */}
            </Document>

            <div className="pageTool" style={{ ...pdfStyle, transform: `rotate(${pdfStyle.rotate}deg)`}}>
            {/* <div className="pageTool"> */}

              <Tooltip title={pageNumber == 1 ? '已是第一页' : '上一页'}>
                <IconFont
                  type="icon-jinru"
                  style={{color: '#fff', transform: 'rotate(180deg)'}}
                  onClick={this.lastPage}
                />
              </Tooltip>
              <div className="page_input">
                <Input
                  style={{width: '100%'}}
                  value={pageNumberFocus ? pageNumberInput : pageNumber}
                  onFocus={this.onPageNumberFocus}
                  onBlur={this.onPageNumberBlur}
                  onChange={this.onPageNumberChange}
                  onPressEnter={this.toPage}
                />
              </div>{' '}
              / {numPages}
              <Tooltip
                title={pageNumber == numPages ? '已是最后一页' : '下一页'}
              >
                <IconFont
                  type="icon-jinru"
                  style={{color: '#fff'}}
                  onClick={this.nextPage}
                />
              </Tooltip>
              <span onClick={() => this.handleChangeDirection(!this.state.isHorizontal)}>{isHorizontal ? '纵屏查看' : '横屏查看'}</span>
              {/* <Tooltip title="放大">
                <IconFont type="icon-tuige" onClick={this.pageZoomIn} />
              </Tooltip>
              <Tooltip title="缩小">
                <span onClick={this.pageZoomOut}>-</span>
              </Tooltip> */}
            </div>
          </div>
        </div>
      )
    )
  }
}

export default PdfLook
